import ListItemAvatar from '@material-ui/core/ListItemAvatar'

export default ListItemAvatar
